import Styles from './BackgroundGrid.module.css'

export interface BackgroundGridProps {
  hasCornerDots?: boolean
  hasRingShine?: boolean
  hasRoundedCorners?: boolean
  hasCursorTrail?: boolean
}

export const defaultProps: Partial<BackgroundGridProps> = {
  hasCursorTrail: true,
}

export const BackgroundGrid = (props: BackgroundGridProps) => {
  const initializedProps: BackgroundGridProps = {...defaultProps, ...props}
  // eslint-disable-next-line no-empty-pattern
  const {} = initializedProps

  return <div className={Styles['BackgroundGrid']}>BackgroundGrid</div>
}
